import React from 'react';
import { UserProfile } from "@clerk/clerk-react";
import { sharedStyles } from '../styles/sharedStyles';

const Profile = () => {
  return (
    <div style={sharedStyles.pageContainer}>
     
      <UserProfile 
              appearance={{
                elements: {
                  // This hides the "Delete account" button
                  accountDangerSection: { display: "none" },
                },
              }}
              routing="path"
              path="/profile"
            />
    </div>
  );
};

export default Profile; 